/** Leaflet grid options to limit off-screen tile churn (timeline overlays). */
export const OSM_OVERLAY_TILE_LAYER_OPTIONS = {
  maxZoom: 18,
  minZoom: 1,
  keepBuffer: 1,
} as const;
